import React, { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import { getOrCreateDialogWithUser, sendPrivateMessage } from "../../messages/api";

export default function SendMessageModal({ targetUser, onClose, onSent }) {
    const [text, setText] = useState("");
    const [error, setError] = useState("");
    const [loading, setLoading] = useState(false);
    const [success, setSuccess] = useState("");
    const [conversationId, setConversationId] = useState(null);
    const inputRef = useRef(null);

    useEffect(() => {
        inputRef.current?.focus();
    }, []);

    const submit = async (event) => {
        event.preventDefault();
        const normalized = text.trim();
        if (!normalized) {
            setError("Введите текст сообщения.");
            return;
        }

        setLoading(true);
        setError("");
        setSuccess("");
        try {
            const dialog = await getOrCreateDialogWithUser(targetUser.id);
            const message = await sendPrivateMessage(targetUser.id, normalized);
            setConversationId(dialog?.conversationId || null);
            setText("");
            setSuccess("Сообщение отправлено.");
            onSent?.(message);
        } catch (requestError) {
            setError(requestError?.response?.data?.error || "Не удалось отправить сообщение.");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="auth-modal-backdrop" onClick={onClose}>
            <div className="auth-modal" onClick={(event) => event.stopPropagation()}>
                <button type="button" className="entity-popup__close" onClick={onClose} aria-label="Закрыть">×</button>
                <h3>Личное сообщение</h3>
                <p>Пользователь: <strong>{targetUser.username || targetUser.email || `#${targetUser.id}`}</strong></p>
                <form onSubmit={submit} className="auth-form">
                    <textarea
                        ref={inputRef}
                        className="ui-textarea"
                        rows={5}
                        value={text}
                        onChange={(event) => setText(event.target.value)}
                        placeholder="Введите сообщение"
                        maxLength={2000}
                        disabled={loading}
                    />
                    <button type="submit" className="toolbar-btn" disabled={loading}>
                        {loading ? "Отправка..." : "Отправить"}
                    </button>
                </form>
                {error && <p className="form-message">{error}</p>}
                {success && <p className="form-message form-message--success">{success}</p>}
                {conversationId && (
                    <Link to={`/messages?conversationId=${conversationId}`} onClick={onClose}>
                        Перейти в диалог
                    </Link>
                )}
            </div>
        </div>
    );
}
